import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import ReactLoading from "react-loading";
import { useHistory } from "react-router-dom";
import {
  PacientInfo,
  InfoBlock,
  InfoTitle,
  Info,
  Content,
  PageTitle,
  Title,
} from "./styles";
import StatusDisplay from "../../../Components/Status";
import MainButton from "../../../Components/MainButton";
import PageContainer from "../../../Components/PageContainer";

export default function PagamentoUnico() {
  const { id } = useParams();
  const [consulta, setConsulta] = useState(null);
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  const fetchRepositoriesData = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/transferencia/detalhes/${id}`);
      setConsulta(response.data);
      console.log("consulta", response.data);
    } catch (error) {
      console.log(error);
    }
    finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRepositoriesData();
  }, [id]);

  if (loading) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Pagamentos</PageTitle>
          <ReactLoading
            type="spin"
            color="#B2EBF2"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  return (
    <Page>
      <SidebarMenu />
      <PageContainer>
        <PageTitle>{consulta?.especialidade ? "Consulta" : "Procedimento"}</PageTitle>
        <Content>
          {consulta?.paciente && (
            <PacientInfo>
              <Title> Informações do Paciente </Title>

              {consulta.afiliado && (
                <>
                  <InfoBlock>
                    <InfoTitle>Nome do Afiliado:</InfoTitle>
                    <Info>{consulta?.afiliado.usuario.NO_primeiro_nome + " " + consulta?.afiliado.usuario.NO_ultimo_nome}</Info>
                  </InfoBlock>
                  <InfoBlock>
                    <InfoTitle>CPF:</InfoTitle>
                    <Info>{consulta?.afiliado.usuario.NU_cpf}</Info>
                  </InfoBlock>
                </>
              )}

              <InfoBlock>
                <InfoTitle>Nome do Titular:</InfoTitle>
                <Info>{consulta?.paciente.usuario.NO_primeiro_nome + " " + consulta?.paciente.usuario.NO_ultimo_nome}</Info>
              </InfoBlock>
              <InfoBlock>
                <InfoTitle>CPF:</InfoTitle>
                <Info>{consulta?.paciente.usuario.NU_cpf}</Info>
              </InfoBlock>

              <InfoBlock>
                <InfoTitle>Email:</InfoTitle>
                <Info>{consulta?.paciente.usuario.DS_email}</Info>
              </InfoBlock>

              <InfoBlock>
                <InfoTitle>Telefone:</InfoTitle>
                <Info>{consulta?.paciente?.usuario.NU_telefone}</Info>
              </InfoBlock>
            </PacientInfo>
          )}
          {consulta?.medico && (
            <PacientInfo>
              <Title> Informações do Médico </Title>
              <InfoBlock>
                <InfoTitle>Nome do Médico:</InfoTitle>
                <Info>{consulta?.medico.usuario.NO_primeiro_nome + " " + consulta?.medico.usuario.NO_ultimo_nome}</Info>
              </InfoBlock>
              <InfoBlock>
                <InfoTitle>CPF:</InfoTitle>
                <Info>{consulta?.medico.usuario.NU_cpf}</Info>
              </InfoBlock>

              <InfoBlock>
                <InfoTitle>Email:</InfoTitle>
                <Info>{consulta?.medico.usuario.DS_email}</Info>
              </InfoBlock>

              <InfoBlock>
                <InfoTitle>Telefone:</InfoTitle>
                <Info>{consulta?.medico?.usuario.NU_telefone}</Info>
              </InfoBlock>
            </PacientInfo>
          )}
          <PacientInfo>
            <Title> Informações da {consulta?.especialidade ? "Consulta" : "Procedimento"} </Title>
            {consulta?.especialidade ?
            <InfoBlock>
              <InfoTitle>Especialidade:</InfoTitle>
              <Info>
                {consulta?.especialidade?.NO_especialidade}
              </Info>
            </InfoBlock>
            :
            <InfoBlock>
              <InfoTitle>Descrição:</InfoTitle>
              <Info>
                {consulta?.DS_transferencia}
              </Info>
            </InfoBlock>
            }
            <InfoBlock>
              <InfoTitle>Valor:</InfoTitle>
              <Info>{consulta?.QT_credito} crédito(s)</Info>
            </InfoBlock>
            <InfoBlock>
              <InfoTitle>Data:</InfoTitle>
              <Info>{new Date(consulta?.DT_criacao).toLocaleDateString("pt-BR")}</Info>
            </InfoBlock>

            <InfoBlock>
              <InfoTitle>Status:</InfoTitle>

              <StatusDisplay status={consulta?.ST_transferencia}>
                {consulta?.ST_transferencia}
              </StatusDisplay>
            </InfoBlock>

            <InfoBlock>
              <InfoTitle>Status do Admin:</InfoTitle>

              <StatusDisplay status={consulta?.ST_transferencia_admin}>
                {consulta?.ST_transferencia_admin}
              </StatusDisplay>
            </InfoBlock>

            <InfoBlock>
              <InfoTitle>Código do Pagamento:</InfoTitle>

              <Info>{consulta?.CD_token}</Info>
            </InfoBlock>
          </PacientInfo>
        </Content>
        <MainButton
          onClick={() =>
            history.push(`/pagamentos-administrador/${id}/pagar`, {
              consulta: consulta,
            })
          }
        >
          Fazer Pagamento
        </MainButton>
      </PageContainer>
    </Page>
  );
}
